import { render, staticRenderFns } from "./AreaAcao.vue?vue&type=template&id=57eb171f"
import script from "./AreaAcao.vue?vue&type=script&lang=js"
export * from "./AreaAcao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports